import React, { useEffect, useState } from 'react';
import socket from '../components/socket'; 
import './assets.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faLock, faCogs, faCopy } from '@fortawesome/free-solid-svg-icons';


class AssetList extends React.Component {

      constructor(props) {
        super(props);
        //state is set at the beginning of the document but can be manipulated at nearly any part of the document.
        this.state = {
          assets: [''],
          companies:[''],
          colors: [],
          currentPage: 0,
          error: 0,
          editAsset:[],
          viewEditMenuWidth: "0",
          updateButtonVisible: "none",
          createButtonVisible: "none",
          assetListColumns: ['ID', 'Name', 'Description', 'Type', 'Quantity', 'Wire Length',
                              'Created By','Color','Company ID','Checked Out','Checked Out To',
                              'Is Available','Installed','Install Location','Location','Shelf ID',
                              'Photo','Product URL', 'Copy'],
          companiesListColumns: ['ID', 'Name', 'Description', 'Created By'],
          assetProperties: {
            id:  0,
            name: "",
            description: "",
            assetType: "",
            quantity: 0,
            wireLength: 0,
            createdBy: "",
            color: 0,
            companyID: "",
            isCheckedOut: "",
            isCheckedOutToWho: "",
            canBeCheckedOut: "",
            installed: "",
            installLocation: "",
            location: "",
            shelfID: "",
            photo: "",
            productURL: ""
          },
          displayAssetList: 'block',
          displayCompaniesList: 'none',
          displayColorList: 'none',
          viewableColumns: ['','','','','','none','none','none','none','none','none','none','none','none','none','none','none','none', ''],
          assetSearchBox: '',
          showSideEdit: 'none',
          addColorMenuWidth: '0',
          twinkDataEmail: '',
          twinkDataPassword: '',
          twinkDataToken: '',
          twinkError: '',
          viewMain: 'none',
          viewLogin: 'block',
          addColor: {
            id: 0,
            colorName: "",
            colorHex: ""
          }
        };

  this.handleEditMenuClose = () => {
    this.setState({viewEditMenuWidth: '0'});
    this.setState({editAsset: ''});
    console.log(this.state.viewEditMenuWidth);
  };

  this.handleAddColorMenuClose = () => {
    this.setState({addColorMenuWidth: '0'});
    console.log(this.state.addColorMenuWidth);
  };

  this.handleEditMenuOpen = (assetDetails) => {
    this.setState({editAsset: assetDetails, viewEditMenuWidth: '20%'});
    this.setState({updateButtonVisible: "", createButtonVisible: "none"});
  };

  this.handleAddColorMenuOpen = () => {
    this.setState({addColorMenuWidth: '20%'});
    console.log("Opening Add Color Menu");
  };

  this.handleCreateAsset = () => {
    let newAsset = this.state.assetProperties;
    newAsset.id = this.state.assets[this.state.assets.length-1].id + 1;
    this.setState({editAsset: ''});
    this.setState({editAsset: newAsset, viewEditMenuWidth: '20%'}); 
    this.setState({updateButtonVisible: "none", createButtonVisible: ""});
    this.setState({addColorMenuWidth: '0'});
  }

  this.createAssetFromTag = (index, value) =>{
    ////console.log(this.state.assets);
    //console.log(e.target.checked);
    let newArr = this.state.editAsset;
    switch(index){
      case 0:
        newArr.id = value;
        break;
    }
    //console.log(e.target.value);
    //console.log(newArr);
    this.setState({editAsset: newArr});
  }

  this.updateEditAsset = index => e =>{
    //console.log(this.state.assets);
    //console.log(e.target.checked);
    let newArr = this.state.editAsset;
    let newColorArr = this.state.addColor;
    console.log(newArr);
    switch(index){
      case 0:
        newArr.id = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 1:
        newArr.name = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 2:
        newArr.description = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 3:
        newArr.assetType = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 4:
        newArr.quantity = Number(e.target.value); 
        this.setState({editAsset: newArr});
        break;
      case 5:
        newArr.wireLength = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 6:
        newArr.createdBy = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 7:
        newArr.color = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 8:
        newArr.companyID = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 9:
        newArr.isCheckedOut = e.target.checked;
        this.setState({editAsset: newArr});
        break;
      case 10:
        newArr.isCheckedOutToWho = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 11:
        console.log(e.target.checked);
        newArr.canBeCheckedOut = e.target.checked;
        this.setState({editAsset: newArr});
        break;
      case 12:
        console.log(e.target.checked);
        newArr.installed = e.target.checked;
        this.setState({editAsset: newArr});
        break;
      case 13:
        newArr.installLocation = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 14:
        newArr.location = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 15:
        newArr.shelfID = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 16:
        newArr.photo = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 17:
        newArr.productURL = e.target.value;
        this.setState({editAsset: newArr});
        break;
      case 100:
        newColorArr.id = e.target.value;
        this.setState({addColor: newColorArr});
      case 101:
        newColorArr.colorName = e.target.value;
        this.setState({addColor: newColorArr});
        console.log(newColorArr.colorName);
      case 102:
        newColorArr.colorHex = e.target.value;
        this.setState({addColor: newColorArr});
        //console.log(this.state.addColor.colorHex );
    }
    // console.log(e.target.value);
    console.log(newColorArr);
    console.log(this.state.addColor.colorName);
    console.log(this.state.addColor.colorHex);
    console.log(newArr);
    
  }

  this.updateSearchAsset = input => e => {
    this.setState({assetSearchBox: e.target.value})
    //console.log('UPDATING SEARCHBOX: ', e.target.value);
  }

  const fakeAssetData = {
    name: 'TesticleMeDaddy',
    description: 'A Quizzicle for your testicle',
    assetType: 1,
    quantity: 5,
    wireLength: 0,
    createdBy: 1,
    color: 2,
    companyID: 1,
    isCheckedOut: false,
    isCheckedOutToWho: "false",
    canBeCheckedOut: true,
    installed: false,
    installLocation: "false",
    location: 3,
    shelfID: 1,
    photo: "GunnersPenis.png",
    productURL: "pornhub.com"
  };

  socket.connect(); 

  socket.on('error', (err) => {
    this.setState({error: err.message});
  });

  this.addAsset = (newAsset) => {
    socket.emit('post_asset', this.state.twinkDataToken, newAsset, (response) => {
      console.log('SEND IT! ', response);
       console.log('asset: ', newAsset);
      socket.emit('list_assets',  this.state.twinkDataToken, (response) => {
        console.log('GOT IT!');
        console.log('Server callback:', response.all_assets);
        this.setState({assets: response.all_assets});
        //this.setState({editAsset: []});
      });
      this.setState({viewEditMenuWidth: '0'});
    });
    
  }

  this.addColor = (color) => {
    socket.emit('post_color', this.state.twinkDataToken, color, (response) => {
      console.log('SEND IT! ', response);
       console.log('color: ', this.state.addColor);
      socket.emit('list_colors',  this.state.twinkDataToken, (response) => {
        console.log('GOT IT!');
        console.log('Server callback:', response.all_colors);
        this.setState({colors: response.all_colors});
        //this.setState({editAsset: []});
      });
      this.setState({addColorMenuWidth: '0'});
    });
    
  }

  this.editAsset = (edittedAsset) => {
    socket.emit('edit_asset', this.state.twinkDataToken, edittedAsset, (response) => {
      console.log('TRIED AGAIN', response.RESLT);
     });
  }

  this.deleteAsset = (id) => {
    if(id){
    socket.emit('delete_asset', this.state.twinkDataToken, id, (response) => {
      console.log('ERASE FROM EXISTENCCEEEE!', response.RESLT);
      socket.emit('list_assets',  this.state.twinkDataToken, (response) => {
        console.log('GOT IT!');
        console.log('Server callback:', response.all_assets);
        this.setState({assets: response.all_assets});
        //this.setState({editAsset: []});
      });
     });
    }
  }
  

  this.searchAsset = () => {
    console.log(parseInt(this.state.assetSearchBox.substring(4,7)));
    if (this.state.assets.find(asset => asset.id === parseInt(this.state.assetSearchBox.substring(3,7))) === undefined){
        this.createAssetFromTag(0, parseInt(this.state.assetSearchBox.substring(4,7)));
        this.handleCreateAsset(this.state.editAsset);
        this.setState({updateButtonVisible: "none", createButtonVisible: ""});
    }else{
        console.log(this.state.assets.find(asset => asset.id === parseInt(this.state.assetSearchBox.substring(3,7))));
        this.handleEditMenuOpen(this.state.assets.find(asset => asset.id === parseInt(this.state.assetSearchBox.substring(3,7))));
    }

  }

  this.updateLists = () => {
    socket.emit('list_colors', this.state.twinkDataToken, (response) => {
      this.setState({colors: response.all_colors});
      console.log('TASTE THE RAINBOWWWW');
      console.log('Server callback:', response);
      console.log(this.state.colors);
    });
    socket.emit('list_assets', this.state.twinkDataToken,  (response) => {
      console.log('GOT IT!');
      console.log('Server callback:', response.all_assets);
      this.setState({assets: response.all_assets});
    });

    socket.emit('list_companies', this.state.twinkDataToken, (response) => {
      console.log('Bring on the Business');
      //console.log('Server callback:', response);
      this.setState({companies: response.all_companies});
    });
  }

  this.showAssetList = () => {
    this.setState({displayAssetList: 'block'});
    this.setState({displayCompaniesList: 'none'});
    this.setState({displayColorList: 'none'});
  }

  this.showCompaniesList = () => {
    this.setState({displayAssetList: 'none'});
    this.setState({displayCompaniesList: 'block'});
     this.setState({displayColorList: 'none'});
  }

  this.showColorList = () => {
    this.setState({displayColorList: 'block'});
    this.setState({displayAssetList: 'none'});
    this.setState({displayCompaniesList: 'none'});
  }
  socket.emit('list_colors', this.state.twinkDataToken, (response) => {
    this.setState({colors: response.all_colors});
    console.log('TASTE THE RAINBOWWWW');
    console.log('Server callback:', response);
    console.log(this.state.colors);
  });
  socket.emit('list_assets', this.state.twinkDataToken,  (response) => {
    //console.log('GOT IT!');
    console.log('Server callback:', response.all_assets);
    this.setState({assets: response.all_assets});
  });

  socket.emit('list_companies', this.state.twinkDataToken, (response) => {
    //console.log('Bring on the Business');
    //console.log('Server callback:', response);
    this.setState({companies: response.all_companies});
  });
  this.handleAssetSearch = (event) => {
    event.preventDefault(); // Prevents the default page reload
    this.searchAsset();
    // Add your desired action here (e.g., send data to a server)
  };

  this.duplicate = () => {
    this.addAsset(this.state.editAsset);
    this.editAsset();
  }

   this.updateLoginUsername = e => {
      console.log(this.state.twinkDataEmail);
      this.setState({twinkDataEmail: e.target.value});
   }

  this.updateLoginPassword = e => {
    console.log(this.state.twinkDataPassword);
    this.setState({twinkDataPassword: e.target.value});
    console.log(this.state.colors);
   }

  this.copyAsset = (assetIDToCopy) => {
    var assetList = this.state.assets;
    var newAsset = assetList.find(asset => asset.id === parseInt(assetIDToCopy));
    newAsset.id = this.state.assets[this.state.assets.length-1].id + 1;
    console.log(newAsset);
    console.log(this.state.assets);
    this.setState({editAsset: newAsset});
    assetList = '';
    this.setState({viewEditMenuWidth: '20%'});
    this.setState({updateButtonVisible: "none", createButtonVisible: ""});
  }

  this.hawtTwink = () => {
    console.log(this.state.twinkDataEmail);
    console.log(this.state.twinkDataPassword);
    socket.emit('hawt_twink', this.state.twinkDataEmail, this.state.twinkDataPassword, (response) => {
      if(response.RESLT === 0){
        this.setState({twinkData: [this.state.twinkDataEmail, '', response.token], viewLogin: 'none', viewMain: 'block'});
        console.log(response.token);
        socket.emit('list_colors', this.state.twinkDataToken, (response) => {
          this.setState({colors: response.all_colors});
          console.log('TASTE THE RAINBOWWWW');
          console.log('Server callback:', response);
          console.log(this.state.colors);
        });
        socket.emit('list_assets', this.state.twinkDataToken,  (response) => {
          //console.log('GOT IT!');
          console.log('Server callback:', response.all_assets);
          this.setState({assets: response.all_assets});
        });

        socket.emit('list_companies', this.state.twinkDataToken, (response) => {
          //console.log('Bring on the Business');
          //console.log('Server callback:', response);
          this.setState({companies: response.all_companies});
        });


      }else{
        this.setState({twinkError: response.RESLT});
        console.log(response.RESLT);
      }
    });
  }


}

render(){
  return (
    <>
    <title>Konvergence AMS</title>
    <head>
      <link rel="icon" href="../../public/logos/icon.png" type="image/png" />
    <script>
      const input = document.createElement("input");
      input.setAttribute("autofocus", "true");
    </script>
    </head>
    <div className='loginForm' style={{display: this.state.viewLogin}}>
    {/* form for submitting the login info to be validated */}
        {/* pane for holding all the login components */}
        <div className='loginPane'>
            {/* logo thats going to be displayed above email and password boxes */}
            <div className="smallLogo" />
            {/* email address div */}
            <div className="loginRowEmail text-fields">
                {/* little person next to email input box */}
                <FontAwesomeIcon icon={faUser} />
                {/* email input box */}
                <input type="email" id="email" value={this.state.twinkDataEmail} className="formInput" placeholder="Email"
                    onChange={this.updateLoginUsername} />
            </div>
            {/* password div */}
            <div className="loginRowPassword text-fields">
                {/* little lock next to password input box */}
                  <FontAwesomeIcon icon={faLock} />
                {/* password input box */}
                <input type="password" id="password" value={this.state.twinkDataPassword} className="formInput" placeholder="Password"
                    onChange={this.updateLoginPassword} />
            </div>
            {/* Submit button for submitting the form */}
            <div className="btn-div"><button className='normalButtons'  onClick={() => this.hawtTwink()}>Login</button></div>                      
            <div className="links-div">
                {/* <form className="links" action="/register">
                    <input type="submit" className="btn-default" value="Register" />
                </form> */}
                <div className="links" action="/forgot">
                    <input type="submit" className="linksButtons" value="Forgot Password" />
                </div>
                
                <div className="links" action="/register">
                    <input type="submit" className="linksButtons" value="Create Account" />
                </div>
            </div>
        </div>
      </div>


    <div style={{ padding: '20px', fontFamily: 'Arial', display: this.state.viewMain }} className='mainPanel'>
     
      {this.state.error && <p style={{ color: 'red' }}>{this.state.error}</p>}
      {/*------- SIDE NAVIGATION ------*/}
      <div className='sideNav'>
        <div className='logo' />
        <div className='sideNavLinks'>
          <a onClick={() => this.showAssetList()}>Assets</a>
          <a onClick={() => this.handleCreateAsset()}>Add Asset</a>
          <a onClick={() => this.showCompaniesList()}>Companies</a>
          <a onClick={() => this.showColorList()}>Colors</a>
          <a onClick={() => this.handleAddColorMenuOpen()}>Color Add</a>
          <a onClick={() => this.updateLists()}>Reload Data</a>
          <a>Logout</a>
        </div>
        <h5> Konvergence Technologies {(new Date().getFullYear())}</h5>
      </div>
      {/*------- SIDE NAVIGATION ------*/}
      {/*------- EDIT ASSET MENU ------*/}
      <div className='sideEdit' id='sideEditForm' style={{width: this.state.viewEditMenuWidth}}>
         <div className='assetIDHeader'>Asset ID: {this.state.editAsset.id}</div>
         <button className='closeEditMenu' onClick={this.handleEditMenuClose}>X</button>
       
        <div className='editAssetPhoto'></div>
        <form className='sideEditForm' style={{display: this.state.viewEditMenuWidth}}>
          <label  className="inputLabel">ID</label>
          <input className='textbox' type='number' placeholder="ID Number" value={this.state.editAsset.id} onChange={this.updateEditAsset(0)} id='name' name='name' required/>

          <label  className="inputLabel">Name</label>
          <input className='textbox' type='text' placeholder="Name" value={this.state.editAsset.name} onChange={this.updateEditAsset(1)} id='name' name='name' required/>

          <label className="inputLabel">Description</label>
          <textarea className='textbox' placeholder='Description' value={this.state.editAsset.description} onChange={this.updateEditAsset(2)} id='desc' rows='3' name='description' />

          <label className="inputLabel">Type</label>
          <input className='textbox' type='number' placeholder='Type' value={this.state.editAsset.assetType} onChange={this.updateEditAsset(3)} id='assetType' name='assetType' />

          <label className="inputLabel">Quantity</label>
          <input className='numberSelector' type='number' placeholder='Quantity' value={this.state.editAsset.quantity} onChange={this.updateEditAsset(4)} id='quantity' name='quantity' />

          <label className="inputLabel">Wire Length</label>
          <input className='numberSelector' type='number' placeholder='Wire Length' value={this.state.editAsset.wireLength} onChange={this.updateEditAsset(5)} id='wireLength' name='wireLength' />

          <label className="inputLabel">Color</label>          
          <select id='color' name='color' value={this.state.editAsset.color} onChange={this.updateEditAsset(7)}>
            {this.state.colors.map((color, index) => (
              <option value={color.id}>{color.colorName}</option>
            ))}
          </select>

          <label className="inputLabel">Company</label>          
          <select name="company" id="company" value={this.state.editAsset.companyID} onChange={this.updateEditAsset(8)}>
            {this.state.companies.map((company, index) => (
              <option value={company.id}>{company.name}</option>
            ))}
          </select>

          <label className="inputLabel">Checked Out?</label>
          <input type="checkbox" id="isCheckedOut" className='checkbox' name="isCheckedOut" onChange={this.updateEditAsset(9)} />

          <label className="inputLabel">Who checked it out</label>
          <input className='textbox' type='text' placeholder='Name' value={this.state.editAsset.isCheckedOutToWho} onChange={this.updateEditAsset(10)} id='whochecked' name='whochecked' />

          <label className="inputLabel">Available for Check out</label>
          <input type="checkbox" className='checkbox' id="canBeCheckedOut" value={this.state.editAsset.canBeCheckedOut} onChange={this.updateEditAsset(11)} name="canBeCheckedOut" />

          <label className="inputLabel">Installed?</label>
          <input type="checkbox" className='checkbox' value={this.state.editAsset.canBeCheckedOut} onChange={this.updateEditAsset(12)} id="isInstalled" name="isInstalled" />
          
          <label className="inputLabel">Install Location</label>
          <input className='textbox' placeholder='Install Location' type='text' value={this.state.editAsset.installLocation} onChange={this.updateEditAsset(13)} id='installLocation' name='installLocation' />
          <label className="inputLabel">Location</label>
          <input className='numberSelector' type='number' placeholder='Location' value={this.state.editAsset.location} onChange={this.updateEditAsset(14)}  id='location' name='location' />
          <label className="inputLabel">Shelf ID</label>
          <input className='textbox' placeholder='Shelf ID' type='text' value={this.state.editAsset.shelfID} onChange={this.updateEditAsset(15)}  id='shelfID' name='shelfID' />
          <label className="inputLabel">Photo</label>
          <input className='textbox' placeholder='Photo' type='text' value={this.state.editAsset.photo} onChange={this.updateEditAsset(16)} id='photo' name='photo' />
          <label className="inputLabel">Product URL</label>
          <input className='textbox' placeholder='Product URL' type='text' value={this.state.editAsset.productURL} onChange={this.updateEditAsset(17)} id='productURL' name='productURL' />
        </form>
        <button className='updateButton' style={{display: this.state.updateButtonVisible}} onClick={() => this.editAsset(this.state.editAsset)}>Update</button>
        <button className='updateButton' style={{display: this.state.createButtonVisible}}  onClick={() => this.addAsset(this.state.editAsset)}>Create</button>
        <button className='deleteButton' onClick={() => this.deleteAsset(this.state.editAsset.id)}>Archive</button>
      </div>
      {/*------- EDIT ASSET MENU ------*/}

      {/*------- ADD COLOR MENU ------*/}
      <div className='sideEdit' id='sideAddColorForm' style={{width: this.state.addColorMenuWidth}}>
         <div className='assetIDHeader'>Asset ID: {this.state.addColor.id}</div>
         <button className='closeEditMenu' onClick={this.handleAddColorMenuClose}>X</button>
       
        <div className='editAssetPhoto'></div>
        <form className='sideEditForm' style={{display: this.state.addColorMenuWidth}}>
          <label  className="inputLabel">ID</label>
          <input className='textbox' type='number' placeholder="ID Number" value={this.state.addColor.id} onChange={this.updateEditAsset(100)} id='id' name='id'/>

          <label  className="inputLabel">Color Name</label>
          <input className='textbox' type='text' placeholder="Name" value={this.state.addColor.colorName} onChange={this.updateEditAsset(101)} id='name' name='name' required/>

          <label className="inputLabel">Color Hex</label>
          <input className='textbox' type='text' value={this.state.addColor.colorHex} onChange={this.updateEditAsset(102)} id='desc' required/>
          
        </form>
        <button className='updateButton' onClick={() => this.addColor(this.state.addColor)}>Create</button>
        <button className='deleteButton'>Archive</button>
      </div>
      {/*------- ADD COLOR MENU ------*/}

      {/*------- Asset List ------*/}
        <div id='assetList' style={{display: this.state.displayAssetList }}>
        <h1>Assets</h1>
          {/*------- SEARCH TEXTBOX ------*/}
          <form id='assetSearchForm' onSubmit={this.handleAssetSearch}>
            <div className='searchControls centerDiv'>
              <input id='searchBox' className='searchbox' value={this.state.assetSearchBox} onChange={this.updateSearchAsset(0)} placeholder='Search' type='text' />
              <button className='searchButton' onClick={() => this.searchAsset(this.state.assetSearchBox)}>Search</button>
            </div>
          </form>
          {/*------- SEARCH TEXTBOX ------*/}
          {/*-------- Column Selection -------*/}
          <div className='columnSelection'>
              <FontAwesomeIcon icon={faCogs} />
          </div>


          <table className='assetTableList centerDiv'>
            <thead>
              <tr>
                {this.state.assetListColumns.map((columnTitle, index) =>
                <th key={index} style={{display: this.state.viewableColumns[index]}}>{columnTitle}</th>
                )}
                {/*<th>Edit</th>
                <th>Archive</th>*/}
              </tr>
            </thead>
            <tbody>
              {this.state.assets.length > 0 && (
               this.state.assets.map((asset, index) => (//console.log(asset),
                <tr key={asset.id} onClick={() => this.handleEditMenuOpen(asset)}>
                  <td style={{display: this.state.viewableColumns[0]}}>{asset.id}</td>
                  <td style={{display: this.state.viewableColumns[1]}}>{asset.name}</td>
                  <td style={{display: this.state.viewableColumns[2]}}>{asset.description}</td>
                  <td style={{display: this.state.viewableColumns[3]}}>{asset.assetType}</td>
                  <td style={{display: this.state.viewableColumns[4]}}>{asset.quantity}</td>
                  <td style={{display: this.state.viewableColumns[5]}}>{asset.wireLength}</td>
                  <td style={{display: this.state.viewableColumns[6]}}>{asset.createdBy}</td>
                  <td style={{display: this.state.viewableColumns[7]}}>{asset.color}</td>
                  {/*<td style={{display: this.state.viewableColumns[8]}}>{this.state.companies.find(company => company.id === 1)}</td>*/}
                  {asset.isCheckedOut ? <td style={{display: this.state.viewableColumns[9]}}>Yes</td> : <td style={{display: this.state.viewableColumns[9]}}>No</td>}
                  <td style={{display: this.state.viewableColumns[10]}}>{asset.isCheckedOutToWho}</td>
                  {asset.canBeCheckedOut ? <td style={{display: this.state.viewableColumns[11]}}>Yes</td> : <td style={{display: this.state.viewableColumns[11]}}>No</td>}
                  {asset.installed ? <td style={{display: this.state.viewableColumns[12]}}>Yes</td> : <td style={{display: this.state.viewableColumns[12]}}>No</td>}
                  <td style={{display: this.state.viewableColumns[13]}}>{asset.installLocation}</td>
                  <td style={{display: this.state.viewableColumns[14]}}>{asset.location}</td>
                  <td style={{display: this.state.viewableColumns[15]}}>{asset.shelfID}</td>
                  <td style={{display: this.state.viewableColumns[16]}}>{asset.photo}</td>
                  <td style={{display: this.state.viewableColumns[17]}}>{asset.productURL}</td>
                  <td style={{display: this.state.viewableColumns[18]}}><button onClick={() => this.copyAsset(asset.id)}><FontAwesomeIcon icon={faCopy} /></button></td>
                </tr>
              )))}
            </tbody>
          </table>

          {this.state.assets.length === 0 && (
            <h2>No assets found</h2>
          )}

        </div>
        {/*------- End Asset List ------*/}
        {/*------- Company List ------*/}
        <div id='companiesList' style={{ marginTop: '20px', display: this.state.displayCompaniesList  }}>
          <h1>Companies</h1>
          {/*------- ADD SEARCH TEXTBOX ------*/}
            <div className='searchControls centerDiv'>
              <input className='searchbox' placeholder='Search' type='text'></input>
              <button className='searchButton'>Search</button>
            </div>
          
          {/*------- ADD SEARCH TEXTBOX ------*/}
          {/*-------- Column Selection -------*/}
          <div className='columnSelection'>
              <div className='fa fa-cog cogIcon' />
          </div>


          <table className='assetTableList centerDiv'>
            <thead>
              <tr>
                {this.state.companiesListColumns.map((columnTitle, index) =>
                <th key={index} style={{display: this.state.viewableColumns[index]}}>{columnTitle}</th>
                )}
                {/*<th>Edit</th>
                <th>Archive</th>*/}
              </tr>
            </thead>
            <tbody>
              {this.state.companies.map((companies, index) => (
                <tr key={companies.id}>
                  <td style={{display: this.state.viewableColumns[0]}}>{companies.id}</td>
                  <td style={{display: this.state.viewableColumns[1]}}>{companies.name}</td>
                  <td style={{display: this.state.viewableColumns[2]}}>{companies.description}</td>
                  <td style={{display: this.state.viewableColumns[3]}}>{companies.createdBy}</td>
                </tr>
              ))}
            </tbody>
          </table>

              </div>
          {/*------- Color List ------*/}
        <div id='colorList' style={{ marginTop: '20px', display: this.state.displayColorList  }}>
          <h1>Colors</h1>
          {/*------- ADD SEARCH TEXTBOX ------*/}
            <div className='searchControls centerDiv'>
              <input className='searchbox' placeholder='Search' type='text'></input>
              <button className='searchButton'>Search</button>
            </div>
            <button className='updateButton' onClick={() => this.handleAddColorMenuOpen}>Add Color</button>
          {/*------- ADD SEARCH TEXTBOX ------*/}
          {/*-------- Column Selection -------*/}
          <div className='columnSelection'>
              <div className='fa fa-cog cogIcon' />
          </div>

          <table className='assetTableList centerDiv'>
            <thead>
              <tr>
                <th key="1">ID</th>
                <th key="2">Color Name</th>
                <th key="3">Color HEX</th>
                {/*<th>Edit</th>
                <th>Archive</th>*/}
              </tr>
            </thead>
            <tbody>
              {this.state.colors.map((color, index) => (
                <tr key={color.id}>
                  <td style={{display: this.state.viewableColumns[0]}}>{color.id}</td>
                  <td style={{display: this.state.viewableColumns[1]}}>{color.colorName}</td>
                  <td style={{display: this.state.viewableColumns[2]}}>{color.colorHex}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {this.state.colors.length === 0 && (
            <h2>No colors found, what is this, 1920???</h2>
          )}
        </div>
      {/*------- End Color List ------*/}

    </div>
    </>
    );
  }
}

export default AssetList;
